//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/NXObject.js";
import "../no/ugmath.js";
let d=[[[0,"IsBlanked",0,0],[0,"NumberOfContourFacets",0,0],[0,"NumberOfContourVertices",0,0]],[[["nVertices"],"GetContourVertices",{R_:{vertices:""}},0,0],[["index"],"GetContourVertexAt",{R_:{vertex:''}},1,0],[["nFacets"],"GetContourFacets",{R_:{facets:""}},0,0],[["index"],"GetContourFacetAt",{R_:{facet:''}},1,0],[["nResults"],"GetSubcaseResults",{R_:{subcaseResults:"DesignSimulation.AnalysisBodySubcaseResults[]"}},0,0],[[],"Blank",{},0,0],[[],"Unblank",{},0,0]],[]];
SPLM.DesignSimulation.AnalysisBodyResults = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.AnalysisBodyResults";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.AnalysisBodyResults.Facet = class{
    constructor(v1,v2,v3){
        this.v1=v1;this.v2=v2;this.v3=v3;}
    get V1(){return this.v1}
    set V1(val){this.v1 = val}
    get V2(){return this.v2}
    set V2(val){this.v2 = val}
    get V3(){return this.v3}
    set V3(val){this.v3 = val}
};

export default SPLM;